export const BASE_PATH = "/";

export const ROUTES = {
  CAREER: "/career",
  CONTACT: "/contact",
  HOME: "/",
} as const;
